import React from 'react';
import PropTypes from 'prop-types';

const StaticBuilderAddAnotherButton = props => (
  <div className="addAnotherButton">
    <button
      type="button"
      className="btn btn-mini btn-primary"
      onClick={props.onAddAdditonalGroup}
    >
      + Add Another
    </button>
  </div>
);

StaticBuilderAddAnotherButton.propTypes = {
  onAddAdditonalGroup: PropTypes.func.isRequired,
};

export default StaticBuilderAddAnotherButton;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderAddAnotherButton.jsx